import { AxiosResponse } from 'axios';
import { flowGptApi } from '../apis';
import {
	InquireFlowGptPayload,
	InquireFlowGptResponse,
	SendFlowGptFeedbackPayload,
	SendFlowGptFeedbackResponse,
} from '../types';

export const inquireFlowGpt = (
	payload: InquireFlowGptPayload,
): Promise<AxiosResponse<InquireFlowGptResponse>> => {
	return flowGptApi.post<InquireFlowGptResponse>('/inquire', {
		question: payload.message,
		site_id: payload.siteId,
		product: payload.currentApp.toLowerCase(),
	});
};
export const sendFlowGptFeedback = (
	payload: SendFlowGptFeedbackPayload,
): Promise<AxiosResponse<SendFlowGptFeedbackResponse>> => {
	return flowGptApi.post<SendFlowGptFeedbackResponse>('/feedbacks', {
		conversation_id: payload.conversationId,
		request_id: payload.requestId,
		feedback_type: payload.feedbackType,
		comment: payload.comment,
		reason: payload.reason,
	});
};
